import {
  ReportReason,
  useGetReportReasonsQuery,
} from "../../../lib/apollo/graphql/generated";
import { useModal } from "../../../hooks/useModal";
import { useState } from "react";

function useReportContainer() {
  const [selectedReason, setSelectedReason] = useState<ReportReason | null>(
    null
  );
  const [isUpdatingReason, { open: openUpdateModal, close: closeUpdateModal }] =
    useModal();

  const { data, loading } = useGetReportReasonsQuery();

  const activeReasons =
    data?.getReportReasons?.filter((reason) => reason.active) || [];

  const inactiveReasons =
    data?.getReportReasons?.filter((reason) => !reason.active) || [];

  const onUpdateReason = (reason?: ReportReason) => {
    setSelectedReason(reason || null);
    openUpdateModal();
  };

  return {
    models: {
      isUpdatingReason,
      selectedReason,
      loading,
      totalCount: data?.getReportReasons?.length,
      activeReasons,
      inactiveReasons,
    },
    operations: {
      onUpdateReason,
      closeUpdateModal,
    },
  };
}

export default useReportContainer;
